import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Button } from "flowbite-react";
import FormInput from "../forms/FormInput";
import { useAuth } from "../../contexts/AuthContext";
import { login } from "../../api/auth";
import { handleError } from "../../services/error";

const LoginForm = () => {
  const navigate = useNavigate();
  const { setAuthUser } = useAuth();

  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const [isProcessing, setIsProcessing] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    setErrors({});

    try {
      const response = await login(formData);
      const { user, token } = response;

      if (!user || !token) {
        toast.error('An unknown error occurred. Please try again.');
        setIsProcessing(false);
        return;
      }

      setAuthUser(user, token);
      navigate('/');
    } catch (err) {
      setIsProcessing(false);
      console.error(err);

      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        handleError(err);
      }
    }
  };

  return (
    <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
      {['username', 'password'].map((field, index) => (
        <FormInput
          key={index}
          input={{
            type: field === 'password' ? 'password' : 'text',
            name: field,
            id: field,
            label: field.charAt(0).toUpperCase() + field.slice(1),
            placeholder: '',
            required: true,
            value: formData[field],
          }}
          onChange={handleChange}
          error={errors?.[field]}
        />
      ))}
      <Button
        type="submit"
        className="w-full"
        isProcessing={isProcessing}
        disabled={isProcessing}
      >
        Login
      </Button>
    </form>
  );
};

export default LoginForm;
